export const UluTraditionalCeremonies = [
  {
      name: "Ngano Silung", 
      img_src:" https://66.media.tumblr.com/106745454539e8dc28d5d7c8aaefdfbb/8111c81f72459d11-4b/s540x810/e2f4c0abd7831fb52e5b67294466705aea5523bb.png",
      description: "Ngano Silung is the traditional culture of the Ulu people to remind the public of the rites held in the longhouse.",
      alt: "ngano-silung"
  }, 

  {
      name: "Upacara Penamaan Anak",
      img_src: "https://66.media.tumblr.com/ecb43a59f43af857c25ca4b3e3270098/8111c81f72459d11-a8/s540x810/4b22bf2b5e701faff7f447d009b6b1c361739446.png",
      description: "In the community of Orang Ulu, Kenyah. The naming ceremony of children's gift is very important. Without naming children, family members will be hated by the community and will never have much dignity. The child's name will be redeemed by the Penatua of the name. The name is chosen by the cautious and appropriate. It can maintain their social strata.", 
      alt: "upacara-penamaan-anak"
  },
  
  {
      name:"Memohon Berkat Batu Tungun",
      img_src:"https://66.media.tumblr.com/92524faee21e5d5d7f10fad8327ce06c/8111c81f72459d11-50/s540x810/f3a1fc28ace77898214693bcacae2bb5dab84a07.png",
      description:"The formation of a stone located on the right bank of SUNGAI MURUN and considered sacred by the Penans in the area from time to time. The stone was used for the blessing.", 
      alt: "memohon-berkat-batu-tungun"
  }, 

  { 
      name: " Peteng ",
      img_src: "",
      description: " Peteng is a proposal ceremony where it involves a man and his family to ask for the woman hand-in-marriage. In marriage, the status of the two parties are very important. For instance, the man has to come from a 'paren' background (is from a high rank and had at least a decapitated enemy's head to represent his bravery and the ability to protect his family). ",
      alt:"peteng"
  },

  {
      name: "Upacara untuk Si Mati",
      img_src:" ",
      description: "Once upon a time, the dead were laid down and bathed by their family in a 'lugun'. 'Lugun' is a wooden casket with holes punctured in in the middle. It was shit and wrapped with rattan. The 'lugun' has carvings on it called 'Kalung Udo'. The mourning period would last for 2-3 days. ",
      alt:"upacara-untuk-si-mati"
  }, 

  {
      name: "Tau Nugan",
      img_src:"https://66.media.tumblr.com/04d67f8615f20cd0d1529c9f3b62297b/f4ef3ad1d14ccd9f-e2/s540x810/14b1f7881a1d9de5ac9afc2cdef5c119d09d0dcd.png ",
      description: "Tau Nugan is a festival for the Kenyah people to mark the beginning of paddy planting season. The festivities involves worshiping the 'bali pa'del' (paddy spirit) for a good harvest. There are a lot of activities being done during the festiviy such as comedic performance, 'burak' drinking', and 'payuh' (An event to test ones ability in self-defense). It was after this festivity that the family members would then go the field to plant their paddy.  ",
      alt: "tau-nugan"
  }, 

  {
      name: "Tau Majau",
      img_src: "https://66.media.tumblr.com/3ff8e6473b3a2d2757f96b402ac1c537/f4ef3ad1d14ccd9f-43/s540x810/cc2e6936cfea971c0dae201031571d24fb223bc2.png ",
      description:" Tau Majau is a festival for the Kenyah people to mark the day of paddy harvest. The festivities involves worshiping the 'bali pa'del' (paddy spirit) for a good harvest. The activities in Tau Majau reflects the activities done during the beginning of paddy planting season festivity, Tau Nugan. ",
      alt: "tau-majau"
  },  

  {
      name: "Mengubur Peralatan bersama Si Mati", 
      img_src : " ",
      description: " When the people of Kelabit dies, certain objects (peralatan) would be buried along with them. The men would be buried along with a 'parang', a form of machete. Whereas the women would be buried with 'belu'ing', a small hoe-like instrument used for tilling and weeding in rice paddies and gardens. It was said that these objects would be a help to the spirits in the land of the dead.",
      alt: "mengubur-peralatan-bersama-si-mati"
  },

  { 
      name: "Upacara Ngelua",
      img_src:" ",
      description: "Upacara Ngelua is a ceremony performed when a person have had bad, inauspicous dreams. The ceremony involves a sacrificing a pig or a chicken and letting its blood smears the left hand of every family members. The blood would have to be left dried for 2-3 days.",
      alt: "upacara-ngelua"
  }, 

  {
      name: "Memberi Tatang kepada Darayah",
      img_src: " ",
      description: "Darayah, a spirit from which the people of Kelabit asks for help and protection, has to given 'tatang', offerings. Every deed done by the people of Kelabit has to not anger or disturb Darayah. To do so, they had to perform certain rituals and sacrifice. For instance, the ritual would involved sacrifying a chicken and letting its blood to drip onto a baby's body.",
      alt: "memberi-tatang-kepada-darayah"
  },

  {
      name: "Penuaian Padi",
      img_src: "https://66.media.tumblr.com/a3a05f6101147ac8f1b72a3f30c47947/29195d19bc46ee31-69/s540x810/7ab17e24b228e72cac2ffc5567872a817c1d873f.png ",
      description: "One of the traditons of the people of Lun Bawan is to hold a celebration on the end of May. The festivity is held to celebrate the time of harvest. During the celebration, there would be dance performances such as Nguip Suling.",
      alt: "penuaian-padi"
  },

  {
      name: "Irau Borak", 
      img_src: "https://66.media.tumblr.com/1df047f88397f1e659e91b4b62303b62/29195d19bc46ee31-76/s540x810/8ac9e082b6772fef16e2e9a868379ba673b2b181.png ",
      description: "Borak or tuak is a type of alcoholic drink made of glutinous rice. Irau Borak is a drinking fest which is usually done after a celebration, weddings, or 'gotong-royong'. ",
      alt: "irau-borak"
  },

  {
      name: "Borak Ate",
      img_src:" https://66.media.tumblr.com/061c13e62ea18426095699f0fe97f020/29195d19bc46ee31-30/s540x810/3d100ce5f16a0ae8207aaa5f7b3a106f354ddd91.png",
      description: " Borak Ate is a ceremony indicating the first stage of burial. It is when the body would be buried in a vessel. The bottom part of the vessel would have a hole whereby a bamboo stick would be poked through. The stick would serve as a pothole for the bodily secretion to flow out onto the ground. The vessel would usually be kept in the homes of the deceased for 2-10 years.",
      alt: "borak-ate"
  },
  
  { 
      name: "Borak Nulang",
      img_src:" https://66.media.tumblr.com/1dc2383460b84bc7644d8506e2b98bc1/29195d19bc46ee31-17/s540x810/6550cdefef23e1bf421c735271bfd133db672ddd.png",
      description: "Borak Nulang is a ceremony indicating the final stage of burial. It is whern the remains of the dead would be relocated into a specific smaller vessel to be buried in 'tempat menauh' (fixed burial ground).",
      alt: "borak-nulang"
  }, 
  
  {
      name: "Kawang & Nabang" ,
      img_src: " ",
      description: " Kawang and Nabang is symbolic ceremony to guide the journey of a spirit to the land of the dead. If it is not done,  it is believed that the spirits would have have a hard time finding its way to the other realm.",
      alt: "kawang-nabang" 
  },
  
  
]; 
